export default {
  // list
  'menu.query.menuName': '菜单名称',
  'menu.query.menuName.placeholder': '输入要查找的菜单名称',
  'menu.query.expandAll': '全部折叠',
  'menu.query.collapseAll': '全部展开',
  'menu.column.menuName': '菜单名称',
  'menu.column.menuIcon': '图标',
  'menu.column.sortNum': '排序',
  'menu.column.path': '访问路径',
  'menu.column.permission': '权限标识',
  'menu.column.component': '组件路径',
  'menu.column.status': '状态',
  'menu.column.status.normal': '正常',
  'menu.column.status.disabled': '禁用',
  'menu.column.visible': '是否可见',
  'menu.column.visible.true': '是',
  'menu.column.visible.false': '否',
  'menu.column.cache': '是否缓存',
  'menu.column.cache.true': '是',
  'menu.column.cache.false': '否',
  'menu.column.dot.true': '是',
  'menu.confirm.delete': '确定要删除"{menuName}"以及该菜单下面所有的菜单吗？',
  // edit
  'menu.edit.title': '修改菜单',
  'menu.add.title': '新增菜单',
  'menu.add.success': '新增成功',
  'menu.edit.success': '修改成功',
  'menu.edit.form.parentId': '上级菜单',
  'menu.edit.form.parentId.placeholder': '请选择上级菜单',
  'menu.edit.form.menuType': '菜单类型',
  'menu.edit.form.menuType.required': '请选择菜单类型',
  'menu.edit.form.menuName': '菜单名称',
  'menu.edit.form.menuName.placeholder': '请输入菜单名称',
  'menu.edit.form.menuName.required': '请输入菜单名称',
  'menu.edit.form.status': '菜单状态',
  'menu.edit.form.status.required': '请选择菜单状态',
  'menu.edit.form.status.normal': '正常',
  'menu.edit.form.status.disabled': '停用',
  'menu.edit.form.sortNum': '显示排序',
  'menu.edit.form.sortNum.placeholder': '请输入显示排序',
  'menu.edit.form.sortNum.required': '请输入显示排序',
  'menu.edit.form.path': '路由地址',
  'menu.edit.form.path.required': '请输入路由地址',
  'menu.edit.form.path.placeholder': '请输入路由地址',
  'menu.edit.form.menuIcon': '菜单图标',
  'menu.edit.form.menuIcon.placeholder': '请选择菜单图标',
  'menu.edit.form.embed': '是否内嵌',
  'menu.edit.form.embedUrl': '内嵌链接',
  'menu.edit.form.embedUrl.placeholder': '请输入内嵌链接',
  'menu.edit.form.component': '组件路径',
  'menu.edit.form.component.placeholder': '以"@/views/"作为相对路径',
  'menu.edit.form.component.required': '请输入组件路径',
  'menu.edit.form.componentName': '组件Name',
  'menu.edit.form.componentName.placeholder': '请输入组件Name',
  'menu.edit.form.permission': '权限标识',
  'menu.edit.form.permission.placeholder': '请输入权限标识',
  'menu.edit.form.visible': '菜单栏显示',
  'menu.edit.form.alwaysShow': '保持显示',
  'menu.edit.form.alwaysShow.tooltip': '当该目录的子菜单只有一项时，该目录是否保持显示。true：显示该目录，false：该目录隐藏直接显示子菜单',
  'menu.edit.form.cache': '是否缓存',
  'menu.edit.form.showHeader': '显示Header',
  'menu.edit.form.showFooter': '显示Footer',
  'menu.edit.form.badge.placeholder': '请输入badge',
}
